import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    const alert = bootstrap.Alert.getOrCreateInstance(this.element)

    setTimeout(function() {
      alert.close();
    }, 4000);
  }
}
